import styled from 'styled-components';
import { Palette } from 'config';

export const PanesContainer = styled.div`
  width: 900px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  overflow: hidden;
`;

export const Pane = styled.div`
  height: 350px;
  border-right: 1px solid ${Palette.PrimaryGray._200};
  padding: 24px;
  overflow-y: auto;
  scrollbar-color: ${Palette.PrimaryGray._300} transparent;

  &::-webkit-scrollbar-track {
    background: ${Palette.PrimaryGray._300};
  }
}
`;

export const PaneTitle = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding-bottom: 24px;
`;

export const Text = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
